import toV1 from '@builder4/shared/migrations/craft/versions/v1';
import toV2 from '@builder4/shared/migrations/craft/versions/v2';
import toV3 from '@builder4/shared/migrations/craft/versions/v3';
import toV4 from '@builder4/shared/migrations/craft/versions/v4';
import toV5 from '@builder4/shared/migrations/craft/versions/v5';
import toV6 from '@builder4/shared/migrations/craft/versions/v6';
import toV7 from '@builder4/shared/migrations/craft/versions/v7';
import toV8 from '@builder4/shared/migrations/craft/versions/v8';
import toV9 from '@builder4/shared/migrations/craft/versions/v9';
import toV10 from '@builder4/shared/migrations/craft/versions/v10';
import toV11 from '@builder4/shared/migrations/craft/versions/v11';
import toV12 from '@builder4/shared/migrations/craft/versions/v12';
import toV13 from '@builder4/shared/migrations/craft/versions/v13';
import toV14 from '@builder4/shared/migrations/craft/versions/v14';
import toV15 from '@builder4/shared/migrations/craft/versions/v15';
import toV16 from '@builder4/shared/migrations/craft/versions/v16';
import toV17 from '@builder4/shared/migrations/craft/versions/v17';
import { MigratableJson } from './MigratableJson';

export const CURRENT_SCHEMA_VERSION = 17;

export type MigrationFunction<T extends MigratableJson> = (json: T) => T;

export interface Migration<T extends MigratableJson = MigratableJson> {
  // The target version this migration upgrades to. Must be a positive integer.
  version: number;
  migrate: MigrationFunction<T>;
}

/**
 * Migration registry containing all CraftJSON schema migrations.
 *
 * See ./documents/migrations.md for more information on how to add a new migration.
 */
export const migrations: Migration[] = [
  {
    version: 1,
    migrate: toV1,
  },
  {
    version: 2,
    migrate: toV2,
  },
  {
    version: 3,
    migrate: toV3,
  },
  {
    version: 4,
    migrate: toV4,
  },
  {
    version: 5,
    migrate: toV5,
  },
  {
    version: 6,
    migrate: toV6,
  },
  {
    version: 7,
    migrate: toV7,
  },
  {
    version: 8,
    migrate: toV8,
  },
  {
    version: 9,
    migrate: toV9,
  },
  {
    version: 10,
    migrate: toV10,
  },
  {
    version: 11,
    migrate: toV11,
  },
  {
    version: 12,
    migrate: toV12,
  },
  {
    version: 13,
    migrate: toV13,
  },
  {
    version: 14,
    migrate: toV14,
  },
  {
    version: 15,
    migrate: toV15,
  },
  {
    version: 16,
    migrate: toV16,
  },
  {
    version: 17,
    migrate: toV17,
  },
];
